export function isProduction(): boolean {
  return process.env.ENV === "production";
}

export function isStaging(): boolean {
  return process.env.ENV === "staging";
}

/** A per-branch deploy (`fa-git-*.preview.blacksmith.sh`, ephemeral stacks); staging.blacksmith.sh is the Vercel preview of main. */
export function isBranchPreview(): boolean {
  return (
    process.env.ENV === "ephemeral" ||
    (process.env.VERCEL_ENV === "preview" &&
      process.env.VERCEL_GIT_COMMIT_REF !== "main")
  );
}

/**
 * `staging` and `preview` keep staging.blacksmith.sh apart from branch
 * previews in Sentry; elsewhere the SDK default stays, so production keeps
 * `vercel-production`.
 */
export function sentryEnvironment(): string | undefined {
  if (isBranchPreview()) return "preview";
  return isStaging() ? "staging" : undefined;
}

export function isProductionOrStaging(): boolean {
  return isProduction() || isStaging();
}

export function isBlacksmithRunner(runnerLabel: string): boolean {
  if (isProduction()) {
    return runnerLabel.startsWith("blacksmith");
  }

  if (isStaging()) {
    return runnerLabel.startsWith("blacksmith-staging");
  }

  // Default to allowing all runners in development
  return true;
}
